import { CommonModule, NgClass, NgFor } from '@angular/common';
import { Component, input, model, output } from '@angular/core';
import { Icon } from '../icon/icon.component';

/** Opção de um seletor em formato de botões (abas). */
export type SelectButtonOption = {
    /** Texto exibido na opção. */
    label: string;
    /** Valor associado à opção. */
    value: any;
    /** Classe de ícone opcional exibida antes do texto. */
    icon?: string;
};

/**
 * Seletor em formato de grupo de botões (estilo abas).
 *
 * Exibe uma opção por botão; a opção ativa é destacada. A seleção é exposta
 * como `model` ({@link selected}) e também emitida via {@link select}.
 */
@Component({
    selector: 'ai-select-button',
    imports: [CommonModule, NgClass, NgFor, NgClass, Icon],
    templateUrl: './select-button.component.html',
})
export class SelectButton {
    /** Opções disponíveis. */
    options = input<SelectButtonOption[]>();

    /** Opção selecionada (two-way via `model`). */
    selected = model<SelectButtonOption>();

    /** Emite a opção escolhida ao clicar. */
    select = output<SelectButtonOption>();

    /** Seleciona a opção clicada e emite {@link select}. */
    onClick(option: SelectButtonOption) {
        this.selected.set(option);
        this.select.emit(option);
    }
}
